const ACTION_GET_COMPANY_INFO = 'ACTION_GET_COMPANY_INFO'
const ACTION_GET_COMPANY_INFO_SUCCESS = 'ACTION_GET_COMPANY_INFO_SUCCESS'

export { ACTION_GET_COMPANY_INFO, ACTION_GET_COMPANY_INFO_SUCCESS }
